<template>
  <SoTextField v-model="reading" label="Enter last reading" type="text" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoTextField from "@/components/formControls/SoTextField.vue"
  import rules from "@/validators/rules"

  export default defineComponent({
    components: {
      SoTextField,
    },
    props: {
      modelValue: {
        type: String,
        default: "",
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        rules,
      }
    },
    computed: {
      reading: {
        get() {
          return this.modelValue
        },
        set(value: string) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>
